export default {"src":"/_next/static/media/section5.49ad9b10.svg","height":399,"width":480,"blurWidth":0,"blurHeight":0};